export function getHSize(pixel: number, baseHeight: number): string {
    return `${(pixel / baseHeight) * 100}vh`;
}

export function getSize(pixel: number, baseWidth: number): string {
    return `${(pixel / baseWidth) * 100}vw`;
}

export const getHeightSize = (pixel: number, baseHeight: number) => {
    return (pixel / baseHeight) * 100;
};

export const getWidthSize = (pixel: number, baseWidth: number) => {
    return (pixel / baseWidth) * 100;
};
